<template>
  <div id="config" class="bg-white rounded-md shadow overflow-x-auto">
    <modal
      v-show="editing"
      :categories="categories"
      :fieldsets="fieldsets"
      :indicator="modal.indicator"
      :name="modal.name"
      :category="modal.category"
      :fieldset="modal.fieldset"
      :order="modal.order"
      :disabled="modal.disabled"
      :min="0"
      :max="order.length - 1"
      @close="stop"
    />

    <table class="w-full whitespace-nowrap">
      <tr class="text-center font-bold">
        <th class="px-6 pt-6 pb-4">Ordem</th>
        <th class="px-6 pt-6 pb-4 text-left">Indicador</th>
        <th class="px-6 pt-6 pb-4">Categoria</th>
        <th class="px-6 pt-6 pb-4">Grupo</th>
        <th class="px-6 pt-6 pb-4">Habilitado</th>
      </tr>

      <tr
        v-for="(indicator, index) in orderedIndicators"
        :key="indicator.id"
        class="hover:bg-gray-100 focus-within:bg-gray-100 my-1 cursor-pointer"
        @click="edit(
          indicator.id,
          indicator.label,
          indicator.category,
          indicator.fieldset,
          orderedIndicators.indexOf(indicator),
          indicator.disabled
        )"
      >
        <td class="border-t my-3 text-center">
          {{ index + 1 }}
        </td>

        <td class="border-t my-3">
          {{ indicator.label }}
        </td>

        <td class="border-t my-3">
          <span class="flex">
            <icon v-if="indicator.category == 1" class="w-6 h-6 m-auto fill-gray-600" name="flag" />
            <icon v-else-if="indicator.category == 2" class="w-6 h-6 m-auto fill-gray-600" name="bus" />
            <icon v-else-if="indicator.category == 3" class="w-6 h-6 m-auto fill-gray-600" name="briefcase" />
            <icon v-else-if="indicator.category == 4" class="w-6 h-6 m-auto fill-gray-600" name="invoice" />
            <icon v-else-if="indicator.category == 5" class="w-6 h-6 m-auto fill-gray-600" name="departure" />
            <icon v-else-if="indicator.category == 6" class="w-6 h-6 m-auto fill-gray-600" name="chart" />
            <icon v-else-if="indicator.category == 7" class="w-6 h-6 m-auto fill-gray-600" name="passport" />
            <icon v-else class="w-6 h-6 m-auto fill-gray-600" name="times" />
          </span>
        </td>

        <td class="border-t my-3 text-center">
          {{ indicator.fieldset == 1 ? 'Planilha' : (indicator.fieldset == 2 ? 'Gráficos' : '-') }}
        </td>

        <td class="border-t my-3 text-center">
          <active-badge :active="!indicator.disabled" />
        </td>
      </tr>

      <tr v-if="indicators.length === 0">
        <td class="border-t text-center px-6 py-4" colspan="5">Nenhum Indicador</td>
      </tr>
    </table>
  </div>
</template>

<script>
import Layout from '@/Pages/Indicators/Layout'
import ActiveBadge from '@/Shared/ActiveBadge'
import Icon from '@/Shared/Icon'
import Modal from '@/Pages/Indicators/Modal'

export default {
  metaInfo: {
    title: 'Indicadores - Configuração',
  },
  components: {
    ActiveBadge,
    Icon,
    Modal,
  },
  layout: Layout,
  props: {
    indicators: Array,
    order:      Array,
    categories: Array,
    fieldsets:  Array,
  },
  data() {
    return {
      orderedIndicators: [],
      editing: false,
      modal: {
        id: null,
        name: null,
        category: null,
        fieldset: null,
        order: null,
        disabled: null,
      },
    }
  },
  mounted() {
    this.orderedIndicators = this.indicators

    this.orderedIndicators.sort((first, second) => this.order.indexOf(first.id) - this.order.indexOf(second.id))

    this.$parent.showMenus(false)
  },
  methods: {
    edit(id, name, category, fieldset, order, disabled) {
      this.editing = true

      this.modal.indicator = id
      this.modal.name      = name
      this.modal.category  = category
      this.modal.fieldset  = fieldset
      this.modal.order     = order
      this.modal.disabled  = disabled
    },
    stop() {
      this.editing = false
    },
  },
}
</script>
